module.exports = __webpack_public_path__ + "img/znjj32.0df40bf9.svg";